exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul.legend{list-style-type:none}.lineChart{border:none;padding-top:1.5em}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/linechart.css
 ** module id = 487
 ** module chunks = 0
 **/